const basePath = () => {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return undefined;
};

export default basePath;
